/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpreviewtitle2Inputs */

const en_ticketpreviewtitle2 = /** @type {(inputs: Ticketpreviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How your ticket looks`)
};

const de_ticketpreviewtitle2 = /** @type {(inputs: Ticketpreviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sieht dein Ticket aus`)
};

/**
* | output |
* | --- |
* | "How your ticket looks" |
*
* @param {Ticketpreviewtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpreviewtitle2 = /** @type {((inputs?: Ticketpreviewtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpreviewtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpreviewtitle2(inputs)
	return de_ticketpreviewtitle2(inputs)
});
export { ticketpreviewtitle2 as "ticketPreviewTitle" }